import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarPage,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
import CreateComponentIcon from '@material-ui/icons/AddCircleOutline';
import CategoryIcon from '@material-ui/icons/Category';
import ExtensionIcon from '@material-ui/icons/Extension';
import HomeIcon from '@material-ui/icons/Home';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import MenuIcon from '@material-ui/icons/Menu';
import MapIcon from '@material-ui/icons/MyLocation';
import SearchIcon from '@material-ui/icons/Search';
import GuardRailIcon from '@material-ui/icons/Security';
import GuidelinesIcon from '@material-ui/icons/Description';
import React, { PropsWithChildren, useState } from 'react';
import { useLocation } from 'react-router-dom';
import MarkDownPreviewIcon from '@material-ui/icons/ViewComfy';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import UtilityIcon from '@material-ui/icons/Build';
import LogoDigitalHangar from '../../assets/LHG_Digital_Hangar_logo.svg';
import StorefrontIcon from '@material-ui/icons/Storefront';
import SduiPreviewIcon from '@material-ui/icons/PhonelinkSetup';

export const Root = ({ children }: PropsWithChildren<{}>) => {
  const [hoveredItem, setHoveredItem] = useState('');
  const [isUtility, setIsUtility] = useState(false);
  const location = useLocation();

  const color = '#05164d';
  const handleMouseOver = (url: string) => {
    setHoveredItem(url.toLowerCase());
  };

  const handleMouseOut = () => {
    setHoveredItem('');
  };

  const getSidebarItemStyle = (
    hoveredItem: string,
    currentPath: string,
    itemKey: string,
    activeColor: string,
  ) => {
    if(currentPath.split('/')[1].toLowerCase()===hoveredItem.toLowerCase()||currentPath?.length===hoveredItem?.length){

      return {
        color:'#fff'
      }
    }
    return {
      color:
        hoveredItem === itemKey && currentPath === itemKey ? activeColor : '',
      cursor:'pointer'
    };
  };

  const getSidebarItemEvents = (
    itemKey: string,
    handleMouseOver: (key: string) => void,
    handleMouseOut: () => void,
  ) => ({
    onMouseOut: handleMouseOut,
    onBlur: handleMouseOut,
    onFocus: handleMouseOut,
    onMouseOver: () => handleMouseOver(itemKey),
    onClick: () => handleMouseOver(itemKey),
  });

  return (
    <SidebarPage>
      <Sidebar>
        <img src={LogoDigitalHangar} alt="logo" style={{ width: '220px' }} />
        <SidebarGroup
         
        >
          <SidebarItem
             icon={SearchIcon}
             to="/search?query="
            text="Search"
            style={getSidebarItemStyle(
              hoveredItem,
              location.pathname,
              'search',
              color,
            )}
            {...getSidebarItemEvents('search', handleMouseOver, handleMouseOut)}
          />
        </SidebarGroup>

        <SidebarDivider />

        <SidebarGroup label="Menu" icon={<MenuIcon />}>
          <SidebarItem
            icon={HomeIcon}
            to="/"
            text="Home"
            style={getSidebarItemStyle(
              hoveredItem,
              location.pathname,
              '',
              color,
            )}
            {...getSidebarItemEvents('/', handleMouseOver, handleMouseOut)}
          />
          <SidebarItem
            icon={CategoryIcon}
            to="catalog"
            text="Catalog"
            style={getSidebarItemStyle(
              hoveredItem,
              location.pathname,
              'catalog',
              color,
            )}
            {...getSidebarItemEvents(
              'catalog',
              handleMouseOver,
              handleMouseOut,
            )}
          />
          <SidebarItem
            icon={ExtensionIcon}
            to="api-docs"
            text="APIs"
            style={getSidebarItemStyle(
              hoveredItem,
              location.pathname,
              'api-docs',
              color,
            )}
            {...getSidebarItemEvents(
              'api-docs',
              handleMouseOver,
              handleMouseOut,
            )}
          />
          <SidebarItem
            icon={LibraryBooks}
            to="docs"
            text="Docs"
            style={getSidebarItemStyle(
              hoveredItem,
              location.pathname,
              'docs',
              color,
            )}
            {...getSidebarItemEvents('docs', handleMouseOver, handleMouseOut)}
          />

          <SidebarItem
            icon={UtilityIcon}
            text="Tools"
            onClick={() => setIsUtility(!isUtility)}
            style={{ cursor: 'pointer' }}
          />
          {isUtility && (
            <div style={{ paddingLeft: '20px' }}>
              <SidebarItem
                icon={CheckCircleIcon}
                to="entity-validation"
                text="Validator"
                style={getSidebarItemStyle(
                  hoveredItem,
                  location.pathname,
                  'entity-validation',
                  color,
                )}
                {...getSidebarItemEvents(
                  'entity-validation',
                  handleMouseOver,
                  handleMouseOut,
                )}
              />
              <SidebarItem
                icon={MarkDownPreviewIcon}
                to="mark-down-preview"
                text="Mark down preview"
                style={getSidebarItemStyle(
                  hoveredItem,
                  location.pathname,
                  'mark-down-preview',
                  color,
                )}
                {...getSidebarItemEvents(
                  'mark-down-preview',
                  handleMouseOver,
                  handleMouseOut,
                )}
              />
              <SidebarItem
                icon={SduiPreviewIcon}
                to="sdui-preview"
                text="SDUI Preview"
                style={getSidebarItemStyle(
                  hoveredItem,
                  location.pathname,
                  'sdui-preview',
                  color,
                )}
                {...getSidebarItemEvents(
                  'sdui-preview',
                  handleMouseOver,
                  handleMouseOut,
                )}
              />
            </div>
          )}
          <SidebarItem
            icon={CreateComponentIcon}
            to="create"
            text="Create..."
            style={getSidebarItemStyle(
              hoveredItem,
              location.pathname,
              'create',
              color,
            )}
            {...getSidebarItemEvents('create', handleMouseOver, handleMouseOut)}
          />
          <SidebarItem
            icon={GuidelinesIcon}
            to="guidelines"
            text="Guidelines"
            style={getSidebarItemStyle(
              hoveredItem,
              location.pathname,
              'guidelines',
              color,
            )}
            {...getSidebarItemEvents(
              'guidelines',
              handleMouseOver,
              handleMouseOut,
            )}
          />
          <SidebarItem
            icon={GuardRailIcon}
            to="guardrails"
            text="Guardrails"
            style={getSidebarItemStyle(
              hoveredItem,
              location.pathname,
              'guardrails',
              color,
            )}
            {...getSidebarItemEvents(
              'guardrails',
              handleMouseOver,
              handleMouseOut,
            )}
          />

          <SidebarScrollWrapper>
            <SidebarItem
              icon={MapIcon}
              to="techRadar"
              text="Tech Radar"
              style={getSidebarItemStyle(
                hoveredItem,
                location.pathname,
                'techRadar',
                color,
              )}
              {...getSidebarItemEvents(
                'techRadar',
                handleMouseOver,
                handleMouseOut,
              )}
            />
          </SidebarScrollWrapper>
          <SidebarScrollWrapper>
            <SidebarItem
              icon={StorefrontIcon}
              to="bazaar"
              text="Working Groups"
               style={getSidebarItemStyle(
                hoveredItem,
                location.pathname,
                'bazaar',
                color,
              )}
              {...getSidebarItemEvents(
                'bazaar',
                handleMouseOver,
                handleMouseOut,
              )}
            />
          </SidebarScrollWrapper>
        </SidebarGroup>

        <SidebarSpace />
        <SidebarDivider />

        <SidebarGroup
          label="Settings"
          icon={<UserSettingsSignInAvatar />}
          to="/settings"
          style={getSidebarItemStyle(
            hoveredItem,
            location.pathname,
            'settings',
            color,
          )}
          {...getSidebarItemEvents('settings', handleMouseOver, handleMouseOut)}
        >
          <SidebarSettings />
        </SidebarGroup>
      </Sidebar>
      {children}
    </SidebarPage>
  );
};
